export default "__VITE_ASSET__UjIaqPKW__"